import { Col, Container, Nav, Row } from 'react-bootstrap';
import Footer from './Footer';

export default function FooterAuth() {
    return (
        <footer>
            <Container>
                <Row>
                    <Col xs={12}>
                        <Nav className='justify-content-center' activeKey='/'>
                            <Nav.Item>
                                <Nav.Link href='/'>بازگشت به داشبورد</Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link href='https://panel.amirreza.dev/'>
                                    بازگشت به سایت داشبورد
                                </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link href='https://amirreza.dev/'>
                                    بازگشت به سایت سازنده
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Col>

                    <div className='space-20' />

                    <Col xs={12} className='d-flex justify-content-center'>
                        <Footer />
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}
